import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetUserListPagingAndFilterRequest } from '../models/request/user/GetUserListPagingAndFilterRequest';

export class UserService {
    static async login(_username: string, _password: string) {
        try {
            var inputObj = {
                username: _username,
                password: _password
            };

            console.log('SERVICE CALL - login', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/User/Login', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportUserList(inputObj: GetUserListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportUserList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/User/exportUserList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getUserListPagingAndFilter(inputObj: GetUserListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - getUserList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/User/GetUserListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addUser(_userId: string | undefined, _nameSurname: string | undefined, _email: string | undefined, _phone: string | undefined, _username: string | undefined, _password: string | undefined, _companyId: string | undefined, _roleIds: string[], _driverId: string | undefined, _personnelId: string | undefined = undefined) {
        try {
            var inputObj = {
                userId: _userId,
                nameSurname: _nameSurname,
                email: _email,
                phone: _phone,
                username: _username,
                password: _password,
                companyId: _companyId,
                roleIds: _roleIds,
                driverId: _driverId,
                personnelId: _personnelId
            }

            // Sifre konsola yazilmaz.
            console.log('SERVICE CALL - AddUser', JSON.stringify({ ...inputObj, password: inputObj.password ? '***' : undefined }));

            const resp = await axios.post(Helpers.getEndpoint() + '/User/AddUser', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Kullanici kendi sifresini degistirir (profil menusu). Basarili olunca tum oturumlari duser. */
    static async changeMyPassword(_currentPassword: string, _newPassword: string): Promise<{ isSuccess: boolean, message: string }> {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/User/ChangeMyPassword', {
                currentPassword: _currentPassword,
                newPassword: _newPassword
            });

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteUser(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteUser', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/User/deleteUser', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getUserById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getUserById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/User/getUserById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}